import { apiPgi } from '../../../config/api'

const pgiService = {
  get: async (idpgi) => {
    const data = await fetchpgicompleto('', idpgi)
    return data
  },
  getHasModificationsPGI: async (project) => {
    const data = await getHasModificationPGI('', project)
    return data
  },
  getPGIperID: async (idpgi) => {
    const data = await getPGIperID(idpgi)
    return data
  },
  getIDPGICurrent: async (project) => {
    const data = await getIDPGICurrent(project)
    return data
  },
  updatePGI: async (pgi) => {
    const data = await updatePGI('', pgi)
    return data
  },
  updatepgiinitial: async (pgi) => {
    const data = await updatepgiinitial('', pgi)
    return data
  },
  createPGIiinitial: async (pgidata) => {
    return await createPGIiinitial('', pgidata)
  },
  createPGIDraft: async (pgidata) => {
    return await createPGIDraft('', pgidata)
  },
  getHistory: async (id) => {
    const { data } = await apiPgi.get(
      `modificationrequest/gethistoricpgilistquery/${id}?api-version=1.0`,
    )

    return data
  },
  getModificated: async (id) => {
    const { data } = await apiPgi.get(`/getmodificationrequestdetail/${id}`)
    return data
  },
  sendPGI: async (pgidata) => {
    return await sendPGI('', pgidata)
  },
  getdraftpgi: async (project) => {
    const data = await getdraftpgi('', project)
    return data
  },
  postVerification: async (verificationId) => {
    return await postVerification('', verificationId)
  },
  postCreateModification: async (modification) => {
    return await postDenyRequest(modification)
  },
  postApprovalRequest: async (modificationRequestId) => {
    return await postApprovalRequest(modificationRequestId)
  },
}

function postApprovalRequest(modificationRequestId) {
  return new Promise((resolve) => {
    apiPgi
      .post(
        'pgi/approvemodificationrequest?api-version=1.0',
        modificationRequestId,
      )
      .then((data) => {
        resolve(data)
      })
      .catch((error) => console.log(error))
  })
}

function fetchpgicompleto(userToken, id) {
  return new Promise((resolve) => {
    apiPgi
      .get(`componentes/componentespgicompleto/${id}?api-version=1.0`)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => console.log(error))
  })
}
function getHasModificationPGI(userToken, id) {
  return new Promise((resolve) => {
    apiPgi
      .get(`pgi/getmodificationrequests/${id}?api-version=1.0`)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => console.log(error))
  })
}
function getPGIperID(id) {
  return new Promise((resolve) => {
    apiPgi
      .get(`componentes/componentespgi/${id}?api-version=1.0`)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => console.log(error))
  })
}
function getIDPGICurrent(id) {
  return new Promise((resolve) => {
    apiPgi
      .get(`pgi/getcurrentpgi/${id}?api-version=1.0`)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => console.log(error))
  })
}
function updatePGI(userToken, data) {
  return new Promise((resolve, reject) => {
    apiPgi
      .post('/pgi/updatepgi?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => reject(error))
    // .catch((error) => resolve(error))
  })
}
function createPGIiinitial(userToken, data) {
  return new Promise((resolve, reject) => {
    apiPgi
      .post('/pgi/createpgiinitial?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      // .catch((error) => resolve(error))
      .catch((error) => reject(error))
  })
}
function createPGIDraft(userToken, data) {
  return new Promise((resolve) => {
    apiPgi
      .post('/pgi/createpgidraft?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function sendPGI(userToken, data) {
  return new Promise((resolve) => {
    apiPgi
      .post('/pgi/createmodificationrequest?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function getdraftpgi(userToken, id) {
  return new Promise((resolve) => {
    apiPgi
      .get(`/pgi/getdraftpgi/${id}?api-version=1.0`)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => console.log(error))
  })
}
function updatepgiinitial(userToken, data) {
  return new Promise((resolve, reject) => {
    apiPgi
      .post('/pgi/updatepgiinitial?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      // .catch((error) => resolve(error))
      .catch((error) => reject(error))
  })
}
function postVerification(userToken, verificationId) {
  return new Promise((resolve) => {
    apiPgi
      .post('/pgi/checkverification?api-version=1.0', {
        verificationId: verificationId,
      })
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function postDenyRequest(modification) {
  return new Promise((resolve) => {
    apiPgi
      .post('pgi/createmodificationrequest?api-version=1.0', modification)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
export default pgiService
